module.exports = __webpack_public_path__ + "img/step3_card@3x.918dcde2.png";